const OL_CSS = 'https://cdn.jsdelivr.net/gh/openlayers/openlayers.github.io@master/en/v6.15.1/css/ol.css';
const OL_JS = 'https://cdn.jsdelivr.net/gh/openlayers/openlayers.github.io@master/en/v6.15.1/build/ol.js';

declare const ol: unknown;

let loading: Promise<void> | null = null;

export function ensureOpenLayers(): Promise<void> {
  if (typeof ol !== 'undefined') {
    return Promise.resolve();
  }
  if (loading) {
    return loading;
  }
  loading = new Promise((resolve, reject) => {
    if (!document.querySelector(`link[href="${OL_CSS}"]`)) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = OL_CSS;
      document.head.appendChild(link);
    }
    const existing = document.querySelector(`script[src="${OL_JS}"]`) as HTMLScriptElement | null;
    if (existing) {
      if (typeof ol !== 'undefined') {
        resolve();
        return;
      }
      existing.addEventListener('load', () => resolve(), { once: true });
      existing.addEventListener('error', () => reject(new Error('Failed to load OpenLayers')), { once: true });
      return;
    }
    const script = document.createElement('script');
    script.src = OL_JS;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load OpenLayers'));
    document.body.appendChild(script);
  });
  return loading;
}
